module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_05 (2).ff8c5338.png";